export default "__VITE_ASSET__7c01e2f5__"